import watchGetAccounts from './getAccounts';
import watchGetSubscriptions from './getSubscriptions';

const watchSubscriptionsImproved = [watchGetAccounts, watchGetSubscriptions];

export default watchSubscriptionsImproved;
